import React, { useEffect, useState, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { Button } from "react-bootstrap";

const ValetTransactionList = ({
  lastFiveTransactionListing,
  lastFiveTransactionsList,
  match,
}) => {
  const headers = [
    "User ID",
    "User Name",
    "Role",
    "Requested By",
    "Approved By",
    "Approver Role",
    "Approved Amount",
    "Status",
    "Active",
    "Created At",
    "Updated At"
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState();



  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await lastFiveTransactionListing(match?.params?.user_id)
     setIsLoading(false)
    })();
  }, []);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await lastFiveTransactionListing(match.params.user_id, val.selected + 1);
    setIsLoading(false);
  };

  useEffect(() => {
    const tableData = [
      "user_id",
      "user_name",
      "role",
      "requested_by_id",
      "approved_by_id",
      "approved_by_role",
      "approved_amount",
      "status",
      "active",
      "created_at"
    ];
    if (lastFiveTransactionsList && lastFiveTransactionsList.resultSets) {
        const data = lastFiveTransactionsList.resultSets.map((element) =>
          Object.assign(
            {},
            ...tableData.map((key) => ({
              [key]:
                key === "active"
                  ? element[key]
                    ? "Active"
                    : "Inactive"
                  : element[key],
            })),
            {
              created_ats: element.created_at,
            }
          )
        );    

      if (data.length > 0) {
        setListData(data);
      } else {
        setListData([]);
      }

      setPageCount(
        Math.ceil(
          lastFiveTransactionsList.total / lastFiveTransactionsList.per_page
        )
      );
    }
  }, [lastFiveTransactionsList]);

  return (
    <Layout
      title={localization.lastFiveTransactionsList}
      isGoback={true}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={true}
        headers={headers}
        pageCount={pageCount}
        srNo={lastFiveTransactionsList?.from}
        onPageChange={onPageChange}
        detailList={
          lastFiveTransactionsList && lastFiveTransactionsList.resultSets
        }
      />
    </Layout>
  );
};

export default ValetTransactionList;
